module.exports = "<!-- This is template for panel tools -->\n<!-- It contains collapse function (showhide) and close function (closebox) -->\n<!-- All function is handled from directive panelTools in directives.js file -->\n<div class=\"panel-tools\">\n    <a ng-click=\"showhide()\"><i class=\"fa-thin fa-chevron-up\"></i></a>\n    <!--<a ng-click=\"closebox()\"><i class=\"fa-thin fa-times\"></i></a>-->\n</div>\n";


//////////////////
// WEBPACK FOOTER
// ./client/common/directives/panelTools/panelTools.html
// module id = 354
// module chunks = 0